/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const SvgComponent: FC<IProps> = ({ width = 19, height = 18, fill = "none" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill={fill}
  >
    <path
      d="M18.5 6L6.5 18M6.5 6L18.5 18"
      stroke="#D35633"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
